import { render, staticRenderFns } from "./SettingsContainer.vue?vue&type=template&id=32cb4b65&"
import script from "./SettingsContainer.vue?vue&type=script&lang=js&"
export * from "./SettingsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SettingsContainer.vue"
export default component.exports